<template>
  <BaseEditModal
    displayName="Preset Conflict"
    helpFileName="OverideLocalPresets"
    icon="mdi-cube-scan"
    hideBottomButtons
    hideTabs
    :masterObj="{}"
    :customState="overwritePresetDialog"
    :tabs="tabs"
    @close="emit('close')">
    <template v-slot:prepend-buttons>
      <v-btn
        variant="flat"
        @click="emit('close')">
        Keep Current
      </v-btn>
    </template>
    <template v-slot:append-buttons>
      <v-btn
        color="primary"
        variant="flat"
        @click="emit('override')">
        Overwrite Presets
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup lang="ts">
import PresetOverrideDialogInner from './PresetOverrideDialogInner.vue';
import BaseEditModal from '@/components/Shared/Modals/BaseEditModal.vue';
const emit = defineEmits({
  close: () => true,
  override: (override: boolean) => override,
});
const props = defineProps(['overwritePresetDialog']);
const tabs = [
  {
    id: 0,
    title: 'Please resolve the following conflicts',
    icon: 'mdi-rename-box',
    display: true,
    component: PresetOverrideDialogInner,
  },
];
</script>
<style scoped></style>
